var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.flagName != null)?_c('div',[_c('v-img',{attrs:{"src":require('../../public/country-flags/' + _vm.flagName),"max-width":"30","max-height":"20"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }